import * as React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { buttonStyles } from './style';
import { classNames } from '../../../utils/classNames';

interface ButtonUIProps {
  onClickHandler: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined;
  className?: string;
  text?: string;
  icon?: React.ReactNode;
  variant?: 'text' | 'contained' | 'outlined' | undefined;
  type?: 'primary' | 'secondary' | 'input';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
}
export default function ButtonUI(props: ButtonUIProps): JSX.Element {
  const {
    onClickHandler,
    text,
    icon,
    variant = 'contained',
    type,
    size = 'small',
    disabled,
    endIcon,
    startIcon,
    className,
  } = props;
  const { button } = buttonStyles;

  const mods = {
    primaryBtn: type === 'primary',
    secondaryBtn: type === 'secondary',
    inputBtn: type === 'input',
  };

  return (
    <>
      {!icon ? (
        <Button
          className={classNames('', mods, [className])}
          onClick={onClickHandler}
          variant={variant}
          sx={button}
          disabled={disabled}
          endIcon={endIcon}
          startIcon={startIcon}
          size={size}
        >
          {text}
        </Button>
      ) : (
        <IconButton
          className={classNames('', {}, [className])}
          aria-label="play-stop"
          size={size}
          onClick={onClickHandler}
          disabled={disabled}
        >
          {icon}
        </IconButton>
      )}
    </>
  );
}
